import { useState } from "react";
import "./ResetPassword.css";
import logo from "../../../../assets/img/topbar/logo.png";
import "react-toastify/dist/ReactToastify.css"; // Import the Toastify CSS
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { Navbar } from "../../../WebUi/Components/HomeV2/Navbar";
import { Footer } from "../../../WebUi/Footer/Footer";

export const ResetPasswordAll = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [password, setPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false); // Toggle for current password visibility
  const [showNewPassword, setShowNewPassword] = useState(false); // Toggle for new password visibility
  const [confirm_password, setConfirmPassword] = useState("");
  const [passwordmatch, setpasswordmatch] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);

  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const role = searchParams.get("role");
  const isValidPassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(password);

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    setPasswordValid(isValidPassword(newPassword));

    // If confirm_password already typed, recheck match
    if (confirm_password) {
      setpasswordmatch(newPassword === confirm_password);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    setpasswordmatch(password === value);
  };
  const handleSubmit = async () => {
    let valid = true;
    if (!isValidPassword(password)) {
      setPasswordValid(false);
      valid = false;
    }

    if (password !== confirm_password) {
      setpasswordmatch(false);
      valid = false;
    }
    if (valid) {
      try {
        const formData = new FormData();
        formData.append("password", password);
        formData.append("password_confirmation", confirm_password);
        formData.append("email", email);
        formData.append("token", token);
        formData.append("role", role);

        const response = await fetch(`${apiUrl}/auth/reset-password`, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          toast.success("Password updated successfully!");
          navigate("/");
        } else {
          const error = await response.json();
          toast.error(error.message || "Failed to update password.");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      }
    }
  };

  return (
    <div>
      <Navbar />
      <section className="LoginCard">
        <div className="container">
          <div className="row">
            <div className="col-lg-3"></div>
            <div className="col-lg-6">
              <form className="LoginInrCard" onSubmit={handleSubmit}>
                <div className="text-center">
                  <img className="img-fluid" src={logo} alt="logo" />
                  <p className="mt-4 mb-1">Welcome Back!</p>
                  <p className="LoginCardTitle">Reset your password</p>
                </div>
                <div>
                  <form>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={showCurrentPassword ? "text" : "password"}
                          className={`form-control ${
                            !passwordValid
                              ? "is-invalid no-validation-icon"
                              : ""
                          }`}
                          id="password"
                          onChange={handlePasswordChange}
                          value={password}
                        />
                        <span
                          className="position-absolute top-50 translate-middle-y"
                          style={{ right: "15px", cursor: "pointer" }}
                          onClick={() =>
                            setShowCurrentPassword((prevState) => !prevState)
                          }
                        >
                          <i
                            className={`fa ${
                              showCurrentPassword ? "fa-eye" : "fa-eye-slash"
                            }`}
                          ></i>
                        </span>
                      </div>
                      {!passwordValid && (
                        <div className="invalid-feedback d-block">
                          Password must be at least 8 characters long and
                          contain at least one uppercase letter, one lowercase
                          letter, one number, and one special character.
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="confirm_password" className="form-label">
                        Confirm Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={showNewPassword ? "text" : "password"}
                          className={`form-control ${
                            !passwordmatch
                              ? "is-invalid no-validation-icon"
                              : ""
                          }`}
                          id="confirm_password"
                          onChange={handleConfirmPasswordChange}
                          value={confirm_password}
                        />
                        <span
                          className="position-absolute top-50 translate-middle-y"
                          style={{ right: "15px", cursor: "pointer" }}
                          onClick={() =>
                            setShowNewPassword((prevState) => !prevState)
                          }
                        >
                          <i
                            className={`fa ${
                              showNewPassword ? "fa-eye" : "fa-eye-slash"
                            }`}
                          ></i>
                        </span>
                      </div>
                      {!passwordmatch ? (
                        <div className="invalid-feedback d-block">
                          Passwords do not match
                        </div>
                      ) : null}
                    </div>
                  </form>
                  <Button
                    className="btn btn-primary mt-4 w-100 kidRegistrSubmtBtn"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </div>
            <div className="col-lg-3"></div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
